<template>
  <div class="view pa24">
    <el-table :data="tableData" v-loading="loading" border>
      <el-table-column type="index" label="序号" width="60" align="center" />
      <el-table-column prop="id" label="任务ID" width="90" align="center" />
      <el-table-column prop="title" label="任务标题" min-width="140" show-overflow-tooltip />
      <el-table-column prop="templateName" label="模板" min-width="120" show-overflow-tooltip />
      <el-table-column prop="totalCount" label="总数" width="80" align="center" />
      <el-table-column prop="successCount" label="成功" width="80" align="center" />
      <el-table-column prop="failCount" label="失败" width="80" align="center" />
      <el-table-column prop="status" label="状态" width="100" align="center">
        <template slot-scope="scope">
          <el-tag size="mini" :type="statusType(scope.row.status)">{{ statusText(scope.row.status) }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="createTime" label="创建时间" width="170" show-overflow-tooltip />
      <el-table-column prop="finishTime" label="完成时间" width="170" show-overflow-tooltip />
      <el-table-column label="操作" width="100" align="center">
        <template slot-scope="scope">
          <el-button type="text" @click="openDetail(scope.row)">明细</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="d-flex justify-content-end mt16">
      <el-pagination
        background
        layout="total, prev, pager, next"
        :total="total"
        :current-page.sync="pageNum"
        :page-size="pageSize"
        @current-change="loadData"
      />
    </div>

    <el-dialog :title="'发送明细 #' + (currentTask && currentTask.id)" :visible.sync="detailVisible" width="860px">
      <div class="mb12">
        <el-radio-group v-model="recordStatus" size="mini" @change="loadRecords">
          <el-radio-button :label="null">全部</el-radio-button>
          <el-radio-button :label="1">成功</el-radio-button>
          <el-radio-button :label="2">失败</el-radio-button>
          <el-radio-button :label="0">待发送</el-radio-button>
        </el-radio-group>
      </div>
      <el-table :data="recordList" v-loading="recordLoading" border max-height="480">
        <el-table-column prop="phone" label="手机号" width="120" />
        <el-table-column prop="customerName" label="客户" width="100" show-overflow-tooltip />
        <el-table-column prop="content" label="文案" min-width="200" show-overflow-tooltip />
        <el-table-column prop="status" label="状态" width="80" align="center">
          <template slot-scope="scope">
            {{ scope.row.status === 1 ? '成功' : scope.row.status === 2 ? '失败' : '待发送' }}
          </template>
        </el-table-column>
        <el-table-column prop="failReason" label="失败原因" min-width="160" show-overflow-tooltip />
        <el-table-column prop="sendTime" label="发送时间" width="160" show-overflow-tooltip />
      </el-table>
      <div class="d-flex justify-content-end mt16">
        <el-pagination
          background
          layout="total, prev, pager, next"
          :total="recordTotal"
          :current-page.sync="recordPage"
          :page-size="recordPageSize"
          @current-change="loadRecords"
        />
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { querySmsTaskPage, querySmsRecordPage } from "@/api/sms";

export default {
  name: "SmsSendRecord",
  data() {
    return {
      loading: false,
      tableData: [],
      total: 0,
      pageNum: 1,
      pageSize: 10,
      detailVisible: false,
      currentTask: null,
      recordLoading: false,
      recordList: [],
      recordTotal: 0,
      recordPage: 1,
      recordPageSize: 10,
      recordStatus: null
    };
  },
  mounted() {
    this.loadData();
  },
  methods: {
    statusText(s) {
      return { 0: "待发送", 1: "发送中", 2: "已完成", 3: "失败" }[s] || "-";
    },
    statusType(s) {
      return { 0: "info", 1: "warning", 2: "success", 3: "danger" }[s] || "info";
    },
    loadData() {
      this.loading = true;
      querySmsTaskPage({ pageNum: this.pageNum, pageSize: this.pageSize })
        .then(res => {
          const page = res && res.data;
          this.tableData = (page && page.list) || [];
          this.total = (page && page.total) || 0;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    openDetail(row) {
      this.currentTask = row;
      this.recordPage = 1;
      this.recordStatus = null;
      this.detailVisible = true;
      this.loadRecords();
    },
    loadRecords() {
      if (!this.currentTask) return;
      this.recordLoading = true;
      querySmsRecordPage({
        taskId: this.currentTask.id,
        recordStatus: this.recordStatus,
        pageNum: this.recordPage,
        pageSize: this.recordPageSize
      })
        .then(res => {
          const page = res && res.data;
          this.recordList = (page && page.list) || [];
          this.recordTotal = (page && page.total) || 0;
        })
        .finally(() => {
          this.recordLoading = false;
        });
    }
  }
};
</script>

<style scoped>
.mt16 {
  margin-top: 16px;
}
.mb12 {
  margin-bottom: 12px;
}
</style>
